import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

export type LogoProps = {
  width?: number;
  showText?: boolean;
  sx?: SxProps<Theme>;
};

export function Logo({ width = 36, showText = true, sx }: LogoProps) {
  const { t } = useTranslation();
  const gradientId = `btsis-logo-gradient-${useId().replace(/:/g, '')}`;
  return (
    <Box
      sx={[
        { display: 'inline-flex', alignItems: 'center', gap: 1.25 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        component="svg"
        viewBox="0 0 48 48"
        sx={{ width, height: width, flexShrink: 0 }}
        aria-hidden
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#5BE49B" />
            <stop offset="100%" stopColor="#007867" />
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="12" fill={`url(#${gradientId})`} />
        <path
          d="M24 34c-5.2-3.6-9-7-9-11.3A5.3 5.3 0 0 1 24 19a5.3 5.3 0 0 1 9 3.7C33 27 29.2 30.4 24 34Z"
          fill="#FFFFFF"
        />
      </Box>
      {showText && (
        <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
          {t('common.appName')}
        </Typography>
      )}
    </Box>
  );
}
